import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

export default function Signup() {
   const emailRef = useRef();
   const passwordRef = useRef();
   const passwordConfirmRef = useRef();
   const { signupEmailPassword } = useAuth();
   const [error, setError] = useState("");
   const [loading, setLoading] = useState(false);
   const navigate = useNavigate();

   async function handleSubmit(e) {
      e.preventDefault();
      if (passwordRef.current.value !== passwordConfirmRef.current.value) {
         return setError("Passwords do not match");
      }
      try {
         setError("");
         setLoading(true);
         await signupEmailPassword(
            emailRef.current.value,
            passwordRef.current.value
         );
         navigate("/");
      } catch (error) {
         console.log(error);
         setError("Failed to create an account");
      }
      setLoading(false);
   }

   return (
      <>
         <Card className="p-4 rounded-4 bg-light">
            <Card.Body>
               <h2 className="text-center mb-4">Sign Up</h2>
               {error && <Alert variant="danger">{error}</Alert>}
               <Form onSubmit={handleSubmit}>
                  <Form.Group id="email">
                     <Form.Label>Email</Form.Label>
                     <Form.Control type="email" ref={emailRef} required />
                  </Form.Group>
                  <Form.Group id="password">
                     <Form.Label>Password</Form.Label>
                     <Form.Control type="password" ref={passwordRef} required />
                  </Form.Group>
                  <Form.Group id="password-confirm">
                     <Form.Label>Password Confirmation</Form.Label>
                     <Form.Control
                        type="password"
                        ref={passwordConfirmRef}
                        required
                     />
                  </Form.Group>
                  <Button
                     disabled={loading}
                     className="w-100 mt-3"
                     type="submit"
                  >
                     Sign Up
                  </Button>
               </Form>
            </Card.Body>
         </Card>
         <div className="w-100 text-center mt-2">
            Already have an account? <Link to="/signin">Sign In</Link>
         </div>
      </>
   );
}
